import { RolesPermissions } from '@components/Admin/RolesPermissions.tsx';

export const AdminPage = () => {
  return <RolesPermissions />;
};
